import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lc-jcd-page',
  templateUrl: './jcd-page.component.html',
  styleUrls: ['./jcd-page.component.scss']
})
export class JcdPageComponent implements OnInit {

  contentblocks = [
    {
      styles: {
        'background-image': 'linear-gradient(180deg, rgba(0, 0, 0, 0.41), transparent 29%), url(/assets/images/jcd/jcd-banner.webp)',
        'background-position': '0px 0px, 50% 50%',
        'height': '600px',
        'padding': '200px 20px 0 20px',
      },
      available_in: ['nl','fr'],
      contentLeft: {
        title: {
          nl: '<h2><strong>Het laatste klinische bewijs</strong></h2>',
          fr: '<h2><strong>Het laatste klinische bewijs</strong></h2>'
        },
        paragraph: {
          nl: 'Vijf gepubliceerde studies in een speciaal nummer van <i>The Journal of Clinical Dentistry®</i>',
          fr: 'Vijf gepubliceerde studies in een speciaal nummer van <i>The Journal of Clinical Dentistry®</i>'
        }    
      },
    },

    {
      styles: {
        'background-image': '', 
        'background-color': '#FFF',
        'padding-top': '50px'
      },
      available_in: ['nl','fr'],
      contentLeft: {
        title: {
          nl: '',
          fr: '',
        },
        paragraph: {
          nl: '',
          fr: '',
        },
        images: [
          {
            url: 'assets/images/jcd/statistic-1.webp',
            styles: {
              'height': '250px'
            }
          },
          {
            url: 'assets/images/jcd/statistic-1-2.webp',
            styles: {
              'height': '250px'
            }
          }
        ]
      },
      contentRight: {
        title: {
          nl: '<h3><strong>Philips Sonicare DiamondClean superieur aan een handtandenborstel</strong><span class="thin"><br/>Vergelijking van Philips Sonicare DiamondClean en een handtandenborstel in de reductie van gingivitis en plaque</span></h3>',
          fr: '<h3><strong>Philips Sonicare DiamondClean superieur aan een handtandenborstel</strong>Vergelijking van Philips Sonicare DiamondClean en een handtandenborstel in de reductie van gingivitis en plaque</h3>'
        },
        paragraph: {
          nl: '<p><i>Delaurenti M, Ward M, Souza S, Jenkins W, Putt MS, MillemanKR, MillemanJL. J Clin Dent 2017;28(Spec Iss A):A1-6<br/><br/></i>Deze studie onderzoekt het effect van de Philips Sonicare DiamondClean in vergelijking met een handtandenborstel in het verminderen van plaque en gingivitis. Deze vier wekende durende studie, met 141 deelnemers, toont aan dat twee keer per dag poetsen met de Philips Sonicare DiamondClean significant beter is dan het gebruik van een handtandenborstel voor de vermindering van plaque en bloeding en het verbeteren van de gezondheid van tandvlees in slechts twee weken.</p>',
          fr: '<p><i style="padding-bottom: 25px;">Delaurenti M, Ward M, Souza S, Jenkins W, Putt MS, MillemanKR, MillemanJL. J Clin Dent 2017;28(Spec Iss A):A1-6</i>Deze studie onderzoekt het effect van de Philips Sonicare DiamondClean in vergelijking met een handtandenborstel in het verminderen van plaque en gingivitis. Deze vier wekende durende studie, met 141 deelnemers, toont aan dat twee keer per dag poetsen met de Philips Sonicare DiamondClean significant beter is dan het gebruik van een handtandenborstel voor de vermindering van plaque en bloeding en het verbeteren van de gezondheid van tandvlees in slechts twee weken.</p>'
        },
        buttons: [
          {
            type: 'external',
            url: 'https://images.philips.com/is/content/PhilipsConsumer/Campaigns/CA20151103_HW_001/17-3566_JCD_Clinical-GingivalHealth_0790_r02_170217_VIEWING.pdf',
            text: {
              nl: 'Download samenvatting',
              fr: ''
            },
            color: 'blue'
          },
          {
            type: 'external',
            url: 'https://images.philips.com/is/content/PhilipsConsumer/Campaigns/CA20151103_HW_001/JCD_28_1SI-Complete_Issue.pdf',
            text: {
              nl: 'Bekijk de speciale editie van JCD',
              fr: ''
            },
            color: 'blue'
          }
        ]
      }
    },

    {
      styles: {
        'background-image': '', 
        'background-color': '#e9eff6',
        'padding-top': '50px',
        'min-height': '700px'
      },
      available_in: ['nl','fr'],
      contentLeft: {
        title: {
          nl: '<h3><strong>Philips Sonicare DiamondClean superieur aan een handtandenborstel</strong><span class="thin"><br/>Vergelijking van Philips Sonicare DiamondClean en een handtandenborstel in de reductie van gingivitis en plaque</span></h3>',
          fr: '<h3><strong>Philips Sonicare DiamondClean superieur aan een handtandenborstel</strong>Vergelijking van Philips Sonicare DiamondClean en een handtandenborstel in de reductie van gingivitis en plaque</h3>'
        },
        paragraph: {
          nl: '<p><i>Delaurenti M, Ward M, Souza S, Jenkins W, Putt MS, MillemanKR, MillemanJL. J Clin Dent 2017;28(Spec Iss A):A1-6<br/><br/></i>Deze studie onderzoekt het effect van de Philips Sonicare DiamondClean in vergelijking met een handtandenborstel in het verminderen van plaque en gingivitis. Deze vier wekende durende studie, met 141 deelnemers, toont aan dat twee keer per dag poetsen met de Philips Sonicare DiamondClean significant beter is dan het gebruik van een handtandenborstel voor de vermindering van plaque en bloeding en het verbeteren van de gezondheid van tandvlees in slechts twee weken.<br/>Verwijdert tot 10 x meer plaque op moelijk bereikbare plaatsen in de DeepClean modus dan een handtandenborstel. Verwijdert 10x meer plaque dan een handtandenborstel (in de hele mond) en vermindert bloeding tot 48% in 2 weken in Deep Clean modus. Deze significante verschillen zijn ook nog zichtbaar op alle gebieden na zes weken. </p>',
          fr: '<p><i>Delaurenti M, Ward M, Souza S, Jenkins W, Putt MS, MillemanKR, MillemanJL. J Clin Dent 2017;28(Spec Iss A):A1-6<br/><br/></i>Deze studie onderzoekt het effect van de Philips Sonicare DiamondClean in vergelijking met een handtandenborstel in het verminderen van plaque en gingivitis. Deze vier wekende durende studie, met 141 deelnemers, toont aan dat twee keer per dag poetsen met de Philips Sonicare DiamondClean significant beter is dan het gebruik van een handtandenborstel voor de vermindering van plaque en bloeding en het verbeteren van de gezondheid van tandvlees in slechts twee weken.<br/>Verwijdert tot 10 x meer plaque op moelijk bereikbare plaatsen in de DeepClean modus dan een handtandenborstel. Verwijdert 10x meer plaque dan een handtandenborstel (in de hele mond) en vermindert bloeding tot 48% in 2 weken in Deep Clean modus. Deze significante verschillen zijn ook nog zichtbaar op alle gebieden na zes weken. </p>',
        },
        buttons: [
          {
            type: 'external',
            url: 'https://images.philips.com/is/content/PhilipsConsumer/Campaigns/CA20151103_HW_001/17-3566_JCD_Clinical-FCPwPCbh_0181_r03_170217_VIEWING.pdf',
            text: {
              nl: 'Download samenvatting',
              fr: ''
            },
            color: 'blue'
          },
          {
            type: 'external',
            url: 'https://images.philips.com/is/content/PhilipsConsumer/Campaigns/CA20151103_HW_001/JCD_28_1SI-Complete_Issue.pdf',
            text: {
              nl: 'Bekijk de speciale editie van JCD',
              fr: ''
            },
            color: 'blue'
          }
        ]
      },
      contentRight: {
        title: {
          nl: '',
          fr: ''
        },
        paragraph: {
          nl: '',
          fr: ''
        },
        images: [
          {
            url: 'assets/images/jcd/statistic-2.webp',
            styles: {
              'height': '250px'
            }
          },
          {
            url: 'assets/images/jcd/statistic-2-2.webp',
            styles: {
              'height': '250px'
            }
          }
        ]

      }
    },

    {
      styles: {
        'background-image': '', 
        'background-color': '#ffffff',
        'padding-top': '50px'
      },
      available_in: ['nl','fr'],
      contentLeft: {
        title: {
          nl: '',
          fr: '',
        },
        paragraph: {
          nl: '',
          fr: '',
        },
        images: [
          {
            url: 'assets/images/jcd/statistic-1.webp',
            styles: {
              'height': '250px'
            }
          },
          {
            url: 'assets/images/jcd/statistic-1-2.webp',
            styles: {
              'height': '250px'
            }
          }
        ]
      },
      contentRight: {
        title: {
          nl: '<h3><strong>Sonisch aangedreven tandenborstels superieur aan handtandenborstels</strong><span class="thin"><br/>Meta-analyse: de effectiviteit van handtandenborstels versus hoge frequentie, hoge amplitude, sonisch aangedreven tandenborstels voor de mondgezondheid</span></h3>',
          fr: '<h3><strong>Sonisch aangedreven tandenborstels superieur aan handtandenborstels</strong><span class="thin"><br/>Meta-analyse: de effectiviteit van handtandenborstels versus hoge frequentie, hoge amplitude, sonisch aangedreven tandenborstels voor de mondgezondheid</span></h3>'
        },
        paragraph: {
          nl: '<p><i>de Jager M, Rmaile A, Darch O, Bikker JW. J Clin Dent 2017;28(Spec Iss A):A13-28<br/><br/></i>Deze nieuwe meta-analyse toont aan dat de  hoge frequentie, hoge-amplitude, sonische tandenborstels significant effectiever zijn in het verminderen van plaque en gingivitis dan een handtandenborstel in dagelijks gebruik in studies tot 3 maanden. De studiecriteria zijn vergelijkbaar met de Cochrane review: Powered/electric toothbrushes compared to manual toothbrushes for maintaining oral health.</p>',
          fr: '<p><i>de Jager M, Rmaile A, Darch O, Bikker JW. J Clin Dent 2017;28(Spec Iss A):A13-28<br/><br/></i>Deze nieuwe meta-analyse toont aan dat de  hoge frequentie, hoge-amplitude, sonische tandenborstels significant effectiever zijn in het verminderen van plaque en gingivitis dan een handtandenborstel in dagelijks gebruik in studies tot 3 maanden. De studiecriteria zijn vergelijkbaar met de Cochrane review: Powered/electric toothbrushes compared to manual toothbrushes for maintaining oral health.</p>',
        },
        buttons: [
          {
            type: 'external',
            url: 'https://images.philips.com/is/content/PhilipsConsumer/Campaigns/CA20151103_HW_001/17-3566_JCD_Clinical-MetaAnalysis_r03_170221_VIEWING.pdf',
            text: {
              nl: 'Download samenvatting',
              fr: ''
            },
            color: 'blue'
          },
          {
            type: 'external',
            url: 'https://images.philips.com/is/content/PhilipsConsumer/Campaigns/CA20151103_HW_001/JCD_28_1SI-Complete_Issue.pdf',
            text: {
              nl: 'Bekijk de speciale editie van JCD',
              fr: ''
            },
            color: 'blue'
          }
        ]
      }
    },

    {
      styles: {
        'background-image': '', 
        'background-color': '#e9eff6',
        'padding-top': '50px',
        'min-height':'600px'
      },
      available_in: ['nl','fr'],
      contentLeft: {
        title: {
          nl: '<h3><strong>Philips Sonicare DiamondClean vs. Oral-B 7000</strong><span class="thin"><br/>Vermindering van gingivitis en plaque door Philips Sonicare DiamondClean met Premium Plaque Control opzetborstel versus Oral-B 7000 met CrossAction opzetborstel.</span></h3>',
          fr: '<h3><strong>Philips Sonicare DiamondClean vs. Oral-B 7000</strong><span class="thin"><br/>Vermindering van gingivitis en plaque door Philips Sonicare DiamondClean met Premium Plaque Control opzetborstel versus Oral-B 7000 met CrossAction opzetborstel.</span></h3>'
        },
        paragraph: {
          nl: '<p><i>Starke M, Delaurenti M, Ward M, Souza S, Milleman KR, Milleman JL. J Clin Dent 2017;28(Spec Iss A):A29-35<br/><br/></i>In een zes weken durende studie de Philips Sonicare DiamondClean met Premium Plaque Control* is bewezen dat deze significant beter presteert in het reduceren van de ontsteking en bloeding van de gingiva en plaque dan Oral-B 7000 met de CrossAction opzetborstel.</p>',
          fr: '<p><i>Starke M, Delaurenti M, Ward M, Souza S, Milleman KR, Milleman JL. J Clin Dent 2017;28(Spec Iss A):A29-35<br/><br/></i>In een zes weken durende studie de Philips Sonicare DiamondClean met Premium Plaque Control* is bewezen dat deze significant beter presteert in het reduceren van de ontsteking en bloeding van de gingiva en plaque dan Oral-B 7000 met de CrossAction opzetborstel.</p>',
        },
      },
      contentRight: {
        images: [
          {
            url: 'assets/images/jcd/statistic-4.webp',
            styles: {
              'height': '250px'
            }
          },
          {
            url: 'assets/images/jcd/statistic-4-2.png',
            styles: {
              'height': '250px'
            }
          }
        ],
        buttons: [
          {
            type: 'external',
            url: 'https://images.philips.com/is/content/PhilipsConsumer/Campaigns/CA20151103_HW_001/17-3566_JCD_Clinical-GingivalHealth_0189_r04_170217_VIEWING.pdf',
            text: {
              nl: 'Download samenvatting',
              fr: ''
            },
            color: 'blue'
          },
          {
            type: 'external',
            url: 'https://images.philips.com/is/content/PhilipsConsumer/Campaigns/CA20151103_HW_001/JCD_28_1SI-Complete_Issue.pdf',
            text: {
              nl: 'Bekijk de speciale editie van JCD',
              fr: ''
            },
            color: 'blue'
          }
        ]
      }
    },

    {
      styles: {
        'background-image': '', 
        'background-color': '#ffffff',
        'padding-top': '50px'
      },
      available_in: ['nl','fr'],
      contentLeft: {
        title: {
          nl: '',
          fr: '',
        },
        paragraph: {
          nl: '',
          fr: '',
        },
        images: [
          {
            url: 'assets/images/jcd/statistic-5.webp',
            styles: {
              'height': '250px'
            }
          },
          {
            url: 'assets/images/jcd/statistic-5-2.webp',
            styles: {
              'height': '250px'
            }
          }
        ]
      },
      contentRight: {
        title: {
          nl: '<h3><strong>Philips Sonicare AirFloss Pro voor interdentale reiniging</strong><span class="thin"><br/>Een studie naar de effecten van Philips Sonicare AirFloss Pro met antimicrobiële spoeling op de gezondheid van de gingiva en plaqueverwijdering</span></h3>',
          fr: '<h3><strong>Philips Sonicare AirFloss Pro voor interdentale reiniging</strong><span class="thin"><br/>Een studie naar de effecten van Philips Sonicare AirFloss Pro met antimicrobiële spoeling op de gezondheid van de gingiva en plaqueverwijdering</span></h3>',
        },
        paragraph: {
          nl: '<p><i>Mwatha A, Olson M, Souza S, Ward M, Jenkins W, Amini P, Gallob J, Fafard T J Clin Dent 2017;28(Spec Iss A):A36-44<br/><br/></i>Dagelijks gebruik van Philips Sonicare AirFloss Pro met antimicrobiële mondspoeling, als aanvulling op het gebruik van een handtandenborstel, verbetert significant de gezondheid van de gingiva en is effectiever in de vermindering van plaque dan een handtandenborstel alleen. Daarnaast toont het onderzoek aan dat de AirFloss Pro net zo effectief is in het verminderen van plaque en gingivitis als flosdraad.</p>',
          fr: '<p><i>Mwatha A, Olson M, Souza S, Ward M, Jenkins W, Amini P, Gallob J, Fafard T J Clin Dent 2017;28(Spec Iss A):A36-44<br/><br/></i>Dagelijks gebruik van Philips Sonicare AirFloss Pro met antimicrobiële mondspoeling, als aanvulling op het gebruik van een handtandenborstel, verbetert significant de gezondheid van de gingiva en is effectiever in de vermindering van plaque dan een handtandenborstel alleen. Daarnaast toont het onderzoek aan dat de AirFloss Pro net zo effectief is in het verminderen van plaque en gingivitis als flosdraad.</p>',
        },
        buttons: [
          {
            type: 'external',
            url: 'https://images.philips.com/is/content/PhilipsConsumer/Campaigns/CA20151103_HW_001/17-3566_JCD_Clinical-GumHealth_PlaqueRemoval_0151_r03_170221_VIEWING.pdf',
            text: {
              nl: 'Download samenvatting',
              fr: ''
            },
            color: 'blue'
          },
          {
            type: 'external',
            url: 'https://images.philips.com/is/content/PhilipsConsumer/Campaigns/CA20151103_HW_001/JCD_28_1SI-Complete_Issue.pdf',
            text: {
              nl: 'Bekijk de speciale editie van JCD',
              fr: ''
            },
            color: 'blue'
          }
        ]
      }
    },
  ]

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/jcd-page/jcd-page.component.ts